import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useStories, useSeo, cmsMediaUrl } from "../lib/cms";
import { ArrowUpRight } from "lucide-react";

const StoriesListPage = () => {
  const { stories, loading } = useStories();
  useSeo({
    title: "Verhalen — Maison Vellore",
    description: "Redactionele verhalen over auto's, reizen en de mensen achter het huis.",
  });

  return (
    <div data-testid="stories-list-page" className="min-h-screen bg-ink-950">
      <Header />
      <main>
        <section className="relative border-b border-white/[0.06]">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-12 pt-24 pb-16 md:pt-32 md:pb-24">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-champagne" />
              <span className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body">
                Editorial
              </span>
            </div>
            <h1 className="font-display text-white text-6xl sm:text-7xl md:text-8xl font-light leading-[0.95] tracking-tight">
              Verhalen.
            </h1>
            <p className="mt-8 max-w-xl text-base md:text-lg text-zinc-300 font-body leading-relaxed">
              Stukken over automobielen, drives, ontmoetingen en de stille kunst
              van het selecteren.
            </p>
          </div>
        </section>

        <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-12 py-16 md:py-24">
          {loading ? (
            <div className="text-sm text-zinc-500 font-body">Verhalen laden...</div>
          ) : stories.length === 0 ? (
            <div className="py-20 text-center text-sm text-zinc-500 font-body">
              Nog geen verhalen gepubliceerd.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
              {stories.map((s, i) => (
                <Link
                  key={s.id}
                  to={`/verhalen/${s.slug}`}
                  data-testid={`story-card-${s.slug}`}
                  className="group flex flex-col bg-ink-900 border border-white/[0.06] hover:border-champagne/30 transition-[border-color] duration-500 animate-fade-up"
                  style={{ animationDelay: `${(i % 6) * 60}ms` }}
                >
                  <div className="relative aspect-[3/2] overflow-hidden bg-ink-850">
                    {s.hero_image ? (
                      <img
                        src={cmsMediaUrl(s.hero_image)}
                        alt={s.hero_image?.alt_text || s.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-ink-900 to-ink-850 flex items-center justify-center">
                        <span className="font-display text-4xl text-champagne/30">
                          MV
                        </span>
                      </div>
                    )}
                    <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center border border-white/10 bg-ink-950/70 backdrop-blur-sm opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-500">
                      <ArrowUpRight size={14} className="text-champagne" />
                    </div>
                  </div>
                  <div className="p-7 flex flex-col gap-4 flex-1">
                    <p className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body">
                      {s.author || "Editorial"}
                    </p>
                    <h2 className="font-display text-2xl md:text-[26px] text-white leading-tight tracking-tight">
                      {s.title}
                    </h2>
                    {s.summary && (
                      <p className="text-sm text-zinc-400 font-body leading-relaxed flex-1">
                        {s.summary}
                      </p>
                    )}
                    <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-body mt-2 hairline-t pt-4">
                      {s.published_at
                        ? new Date(s.published_at).toLocaleDateString("nl-NL", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          })
                        : ""}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default StoriesListPage;
